import React, { FC } from 'react';
import { Spin } from 'antd';
import SelectServices from '~/components/views/ServicesView/SelectServices';
import { useGetApplication } from '~/controllers/wizard';
import { Draft } from '~/types/Draft';
import { useGetDraft } from '~/controllers/draft';

const Services: FC<void> = () => {
  const draftQuery = useGetDraft<Draft<'services'>>();
  const applicationQuery = useGetApplication();
  if (draftQuery.isLoading || applicationQuery.isLoading) return <Spin />;
    return <SelectServices />;

};

export default Services;
